import React, { useEffect } from "react";
import "./AboutTPL.css";
import {
  Target,
  Users,
  Flame,
  ShieldCheck,
  TrendingUp,
  Compass,
  Award,
  Globe
} from "lucide-react";

const SportsAbout = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="about-tpl-page">
      {/* ---------- HERO SECTION ---------- */}
      <section className="about-premium-hero">
        <div className="hero-bg-overlay"></div>
        <div className="hero-content reveal">
          <div className="hero-tag">About ATPL</div>
          <h1 className="hero-main-title">Forging the Future of <span>Indian Sports</span></h1>
          <p className="hero-description">
            A celebration of skill, dedication, and the relentless pursuit of excellence. We empower young talents to reach their full potential on the national stage.
          </p>
        </div>
      </section>

      {/* ---------- IDENTITY SECTION ---------- */}
      <section className="identity-section reveal">
        <div className="identity-container">
          <div className="identity-visual">
            <div className="logo-glass-frame">
              <img src="/Images/AATTUM-Logo.png" alt="ATPL Logo" />
            </div>
            <div className="experience-tag">
              <span className="years">3+</span>
              <span className="text">Years of Legacy</span>
            </div>
          </div>
          <div className="identity-text">
            <h2 className="section-header">Who We Are</h2>
            <p className="primary-text">
              Aattum TPL Sports League is a premier platform created to spotlight the energy and talent of India's youth across all sporting disciplines.
            </p>
            <p className="secondary-text">
              Our journey began in 2022 with a singular vision: to bridge the gap between passion and professional recognition. Today, we stand on the field as a beacon for rising stars, providing world-class opportunities and professional ecosystems where limits are tested and champions are born.
            </p>
            <div className="identity-stats">
              <div className="stat-item">
                <span className="stat-val">District</span>
                <span className="stat-label">to National level</span>
              </div>
              <div className="stat-item">
                <span className="stat-val">Professional</span>
                <span className="stat-label">Standards</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- VISION & MISSION ---------- */}
      <section className="vision-mission-premium reveal">
        <div className="container">
          <h2 className="section-header-centered">Our Purpose</h2>
          <div className="vm-grid">
            <div className="vm-card-premium">
              <div className="card-icon-box">
                <Target size={32} />
              </div>
              <h3>Our Vision</h3>
              <p>
                To become India’s most trusted multi-sports talent platform, inspiring and uplifting young athletes through world-class opportunities. We strive to build a powerful sports ecosystem that nurtures future champions and creates a lasting impact on India’s sporting heritage.
              </p>
            </div>
            <div className="vm-card-premium">
              <div className="card-icon-box">
                <Compass size={32} />
              </div>
              <h3>Our Mission</h3>
              <p>
                To conduct high-quality, transparent tournaments across multiple sports while identifying and promoting emerging talent from every region. We are committed to nurturing athletes with fair opportunities and professional exposure, ensuring equal growth pathways for both Men and Women.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- OUR JOURNEY ---------- */}
      <section className="journey-premium reveal">
        <div className="journey-container">
          <div className="journey-content">
            <h2 className="section-header">The Journey So Far</h2>
            <div className="journey-timeline-item">
              <div className="timeline-marker"></div>
              <p>
                Started with a vision to discover hidden sports talents, our journey reflects passion, dedication, and community growth. Every year, we witness inspiring stories of transformation through teamwork and perseverance.
              </p>
            </div>
            <div className="journey-timeline-item">
              <div className="timeline-marker"></div>
              <p>
                From humble beginnings in 2022 to organizing nationwide tournaments, we’ve built a space where sports meet opportunity. Every success story motivates us to reach further and inspire more.
              </p>
            </div>
            <div className="journey-highlights">
              <div className="highlight"><Award size={20} /> Verified Impact</div>
              <div className="highlight"><Globe size={20} /> Nationwide Reach</div>
            </div>
          </div>
          <div className="journey-visual">
            <div className="image-stack">
              <img src="/Images/sport6.jpg" alt="ATPL Journey" className="main-j-img" />
              <div className="visual-accent-box"></div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- VALUE PROPS ---------- */}
      <section className="atpl-difference-premium reveal">
        <div className="container">
          <div className="diff-header">
            <h2 className="section-header-centered">The ATPL Advantage</h2>
            <p className="diff-subtitle">Where Passion Meets Opportunity. We provide the platform, you provide the talent.</p>
          </div>
          <div className="diff-grid">
            <div className="diff-card">
              <Users className="diff-icon" size={28} />
              <h4>Equal Opportunities</h4>
              <p>Regardless of background, gender, or experience, every athlete gets a fair chance to shine in well-structured leagues.</p>
            </div>
            <div className="diff-card">
              <ShieldCheck className="diff-icon" size={28} />
              <h4>Professional Standards</h4>
              <p>Certified officials and professional management ensure every match meets the highest standards of competitive sports.</p>
            </div>
            <div className="diff-card">
              <Flame className="diff-icon" size={28} />
              <h4>Talent Scouting</h4>
              <p>Direct exposure to scouts and clubs identifies promising talent for advanced training and professional career paths.</p>
            </div>
            <div className="diff-card">
              <TrendingUp className="diff-icon" size={28} />
              <h4>National Recognition</h4>
              <p>Our expanding nationwide reach provides athletes with the visibility needed to move from local fields to national stadiums.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- CTA SECTION ---------- */}
      <section className="about-cta reveal">
        <div className="cta-box">
          <h2>Ready to Join the Revolution?</h2>
          <p>Register now and take your first step toward professional sports excellence.</p>
          <button className="premium-btn">Register with us</button>
        </div>
      </section>
    </div>
  );
};

export default SportsAbout;
